<div class="modal-body edit-date-time-modal">
  <button type="button" class="close error_btn" aria-label="Close" data-dismiss="modal" (click)="close()"><span
    aria-hidden="true" class=""><img src="/assets/images/checkout/close_icon.svg"></span></button>
  <div class="modifyDatePopup">
    <div class="text-center header-title mb-3">
      Parking Reservation Time
    </div>

    <div class="row">
      <div class="col-lg-7 col-md-6 col-12 pd-right">
        <div class="col-12 field-title">Check-in Date</div>
        <div class="input-group col-12 pd-right">
          <span id="startDate" class="form-control select-input-clndr"
            readonly (click)="openCalender('from')">{{startDateModel | date }}</span>

          @if (isCheckIn) {
            <div class="clndr-new checkin"  (document:click)="onDocumentClick($event,'input-group','checkin')">
              <multiple-date-picker id="calendar_view" [showDaysOfSurroundingMonths]="false" [disallowBackPastMonths]="true"
                [sundayFirstDay]="true" [disableDaysBefore]="today" [highlightDays]="highlightDays" [dayClick]="onDaySelect"
                [selectedDays]="selectedDays" [month]='dateSelectedMonth'  >
              </multiple-date-picker>
            </div>
          }
        </div>
      </div>
      <div class="col-lg-5 col-md-6 col-12">
        <div class="col-12 field-title pd-left">Check-in Time</div>
        <div class="input-group col-12 pd-left ">
          <input class="form-control select-input checkin-cls" readonly [(ngModel)]="selectedStartTimeToShow"
            placeholder="12:00 AM" (click)="toggleListVisibility('from')" #inputBox>
          @if (showTimeList) {
            <div class="tmpro checkin"
              (document:click)="onDocumentClick($event,'checkin-cls','checkin')">
              <div class="tpl" id="tpl">
                <ul>
                  @for (checkinTime of timeArray; track checkinTime; let i = $index) {
                    <li id="prctm{{i}}"
                      [ngClass]="{'active': selectedStartTimeToShow == checkinTime.dsply}"
                      (click)="selectTime(checkinTime,'from')">
                      {{ checkinTime.dsply }}
                    </li>
                  }
                </ul>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-7 col-md-6 col-12 pd-right">
        <div class="col-12 field-title">Check-out Date</div>
        <div class="input-group choutbx col-12 pd-right">
          <span id="startDate" class="form-control select-input-clndr"
            readonly (click)="openCalender('to')">{{endDateModel | date}}</span>

          @if (isCheckOut) {
            <div class="clndr-new checkout"  (document:click)="onDocumentClick($event,'choutbx','checkout')">
              <multiple-date-picker id="calendar_view_checkout" [showDaysOfSurroundingMonths]="false" [disallowBackPastMonths]="true"
                [sundayFirstDay]="true" [disableDaysBefore]="today" [highlightDays]="highlightDaysCheckout" [dayClick]="onDaySelect"
                [selectedDays]="selectedDaysCheckOut" [month]='dateSelectedMonthCheckout'  >
              </multiple-date-picker>
            </div>
          }
        </div>
      </div>

      <div class="col-lg-5 col-md-6 col-12">
        <div class="col-12 field-title pd-left">Check-out Time</div>
        <div class="input-group col-12 pd-left">
          <input class="form-control select-input checkout-cls" readonly [(ngModel)]="selectedEndTimeToShow"
            placeholder="12:00 AM" (click)="toggleListVisibility('to')" #inputBoxCheckout>
          @if (showTimeListTo) {
            <div class="tmpro checkout"
              (document:click)="onDocumentClick($event,'checkout-cls','checkout')">
              <div class="tpl" id="tpl">
                <ul>
                  @for (checkoutTime of endTimeArray; track checkoutTime; let i = $index) {
                    <li id="prct{{i}}"
                      [ngClass]="(selectedEndTimeToShow == checkoutTime.dsply) ? 'active' : ''"
                      (click)="selectTime(checkoutTime,'to')">
                      {{checkoutTime.dsply}}
                    </li>
                  }
                </ul>
              </div>
            </div>
          }
        </div>
      </div>
      @if (errorMessage!=='') {
        <div class="col-12 text-danger mt-2 ml-3 err-msg">{{errorMessage}}</div>
      }
      <div class="col-12 text-center btn-bx">
        <button class="apply-btn" (click)="updateDateTimeWithNew()">APPLY</button>
      </div>
    </div>
  </div>
</div>
